import { resolveLink as T, resolveLinkedPageImage as N } from "../../../helpers/index.js";
import { ListType as n } from "./List.types.js";
const f = (r) => {
  switch (r) {
    case null:
    case "Artikler":
    case "Artikel":
      return n.article;
    case "Nyheder":
    case "Nyhed":
      return n.news;
    case "Podcast":
    case "Podcasts":
      return n.podcast;
    default:
      return n.all;
  }
}, L = (r, m, y) => {
  const a = f(r.properties?.articleTypes), c = r.properties?.contentTag?.[0]?.name, o = r.properties?.pinnedContent, p = m.filter((e) => e.id !== y), u = p.filter(
    (e) => a === n.all ? e : f(e.properties?.articleType) === a
  );
  let l;
  !c || c.length < 1 ? l = u : l = u?.filter(
    (e) => e.properties?.contentTags?.some(
      (i) => i.name === c
    )
  );
  const g = l?.sort(
    (e, i) => new Date(i.properties?.date).getTime() - new Date(e.properties?.date).getTime()
  ), s = [];
  if (o && o.length > 0) {
    const e = p.find((t) => t.id === o[0]?.id);
    e && s.push(e);
    const i = p.find((t) => t.id === o[1]?.id);
    i && s.push(i);
    const d = p.find((t) => t.id === o[2]?.id);
    d && s.push(d);
    const h = p.find((t) => t.id === o[3]?.id);
    h && s.push(h);
    const w = g.filter(
      (t) => t.id !== e?.id && t.id !== i?.id && t.id !== d?.id && t.id !== h?.id
    );
    s.push(...w);
  } else
    s.push(...g);
  return s?.map((e) => {
    const i = f(e.properties?.articleType), d = {
      header: e.properties?.header,
      description: e.properties?.teaser,
      date: i === n.news && new Date(e.properties?.date),
      link: T({ route: e.route })
    };
    return a === n.news ? {
      ...d,
      variant: "withoutImage"
    } : {
      ...d,
      variant: "withImage",
      image: N(e),
      tag: i
    };
  });
}, A = (r) => ({
  header: r.properties?.header,
  items: [],
  // Items are being fetched from the taggedContent property on UmbracoGrid instead.
  variant: "weighted",
  readMore: r.properties?.link && T(r.properties?.link)
});
export {
  A as listDeliveryApiParser,
  L as listDeliveryTaggedContentFilter
};
